import React, { useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import { CGU_CONTENT } from '../../data/legalContent';

const TermsModal = () => {
  const { termsCheck, acceptTerms } = useAuth();
  const [loading, setLoading] = useState(false);

  if (!termsCheck?.mustAccept) return null;

  const handleAccept = async () => {
    setLoading(true);
    try {
      await acceptTerms(termsCheck.latestVersion);
    } catch (error) {
      console.error("Failed to accept terms", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/90 backdrop-blur-md p-4">
      <div className="bg-slate-900 border border-slate-700 rounded-2xl max-w-2xl w-full shadow-2xl overflow-hidden flex flex-col max-h-[90vh] animate-in fade-in zoom-in duration-300">
        <div className="p-6 border-b border-slate-800 bg-slate-900/50">
          <h2 className="text-2xl font-bold text-white">Mise à jour des Conditions Générales</h2>
          <p className="text-slate-400 text-sm mt-2">
            Nous avons mis à jour nos conditions d'utilisation. Veuillez les lire et les accepter pour continuer à utiliser Muzo Studio.
          </p>
        </div>
        
        <div className="p-6 overflow-y-auto text-slate-300 text-sm space-y-4 flex-1 bg-slate-950/30">
          <div className="prose prose-invert prose-sm max-w-none">
            <p className="text-xs text-slate-500 uppercase tracking-wider font-semibold mb-4">
              Dernière mise à jour : {termsCheck.latestDate ? new Date(termsCheck.latestDate).toLocaleDateString() : CGU_CONTENT.lastUpdated}
            </p>
            
            {CGU_CONTENT.sections.map((section, index) => (
              <div key={index} className="mb-6">
                <h3 className="text-lg font-semibold text-white mb-2">{section.title}</h3>
                {section.content.map((paragraph, pIndex) => (
                  <p key={pIndex} className="mb-2 text-slate-400">
                    {paragraph}
                  </p>
                ))}
              </div>
            ))}
          </div>
        </div>

        <div className="p-6 border-t border-slate-800 bg-slate-900/50 flex flex-col sm:flex-row justify-end gap-3 items-center">
          <p className="text-xs text-slate-500 text-center sm:text-left mr-auto">
            En cliquant sur "J'accepte", vous confirmez avoir lu et approuvé les nouvelles conditions.
          </p>
          <button
            onClick={handleAccept}
            disabled={loading}
            className="w-full sm:w-auto px-8 py-3 bg-indigo-600 hover:bg-indigo-500 text-white rounded-xl font-semibold transition-all shadow-lg shadow-indigo-500/20 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2"
          >
            {loading ? (
              <>
                <svg className="animate-spin h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
                Traitement...
              </>
            ) : (
              'J\'accepte les CGU'
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default TermsModal;
